module.exports = __webpack_public_path__ + "static/media/simple.294566f8.vert";